import { render } from "./contador.vue?vue&type=template&id=6a3f394c&scoped=true"
import script from "./contador.vue?vue&type=script&lang=js"
export * from "./contador.vue?vue&type=script&lang=js"

import "./contador.vue?vue&type=style&index=0&id=6a3f394c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a3f394c"]])

export default __exports__